import React from 'react';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import SocialRegistration from './components/SocialRegistration';
import TrustSignals from './components/TrustSignals';

const RegistrationScreen = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start max-w-6xl mx-auto">
          {/* Left Column - Registration Form */}
          <div className="w-full max-w-md mx-auto lg:mx-0">
            <div className="bg-card border border-border rounded-xl shadow-tier-2 p-8">
              <RegistrationHeader />
              
              <div className="mt-8 space-y-6">
                <RegistrationForm />
               {/* TODO: WORKING ON THIS: REENABLE THIS
               <SocialRegistration /> */}
              </div>
            </div>
          </div>

          {/* Right Column - Trust Signals (Desktop Only) */}
          <div className="hidden lg:block">
            <div className="sticky top-8">
              <TrustSignals />
            </div>
          </div>
        </div>

        {/* Mobile Trust Signals */}
        <div className="lg:hidden mt-12 max-w-md mx-auto">
          <TrustSignals />
        </div>

        {/* Footer */}
        <footer className="mt-16 text-center">
          <div className="space-y-4">
            <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground font-caption">
              <button 
                type="button"
                className="hover:text-foreground transition-micro"
                onClick={() => window.open('/terms', '_blank')}
              >
                Termos de Uso
              </button>
              <button 
                type="button"
                className="hover:text-foreground transition-micro"
                onClick={() => window.open('/privacy', '_blank')}
              >
                Privacidade
              </button>
              <button 
                type="button"
                className="hover:text-foreground transition-micro"
                onClick={() => window.open('/help', '_blank')}
              >
                Ajuda
              </button>
            </div>
            
            <p className="text-xs text-muted-foreground font-caption">
              © {new Date()?.getFullYear()} Academy Platform. Todos os direitos reservados.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default RegistrationScreen;